// extracted by mini-css-extract-plugin
export var active = "_cq-2";
export var recordingDot = "_cq-1";
export var recordingIndicator = "_cq-0";